import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useStore } from '../store';
import { hasValidSubscription } from '../utils/subscription';

interface Props {
  children: ReactNode;
}

/**
 * Wraps protected content and redirects to /subscribe if subscription is invalid
 */
export default function SubscriptionGate({ children }: Props) {
  const { subscription } = useStore();

  // If subscription is invalid, redirect to subscribe page
  if (!hasValidSubscription(subscription)) {
    return <Navigate to="/subscribe" replace />;
  }

  return <>{children}</>;
}
